import Vue from 'vue';
import moment from 'moment/moment.js';

const $site = {
    loading: {
        open: (container) => {
            try {
                $(container).addClass('vs-con-loading__container');
                Vue.prototype.$vs.loading({
                    container: container
                });
            }
            catch(err) {

            }
        },
        close: (container) => {
            $(container).removeClass('vs-con-loading__container').find('.con-vs-loading').remove();
        },
    },
    notification: {
        request: () => {
            try {
                Notification.requestPermission().then((permission) => {
                    if (permission === 'granted') {
                        registerSW();
                        subscribe();
                    }
                });
            }
            catch (error) {}
        }
    },
    number: {
        format: (number, delimeter=',', fixed=0) => {
            if(isNaN(number)) return 0;
            number = parseInt(number).toFixed(fixed);
            number += '';
            let rgx = /(\d+)(\d{3})/;
            while (rgx.test(number)) {
                number = number.replace(rgx, '$1' + delimeter + '$2');
            }
            return number;
        }
    },
    date: {
        parseDBDate: (date, format = "DD/MM/YYYY") => {
            if(date) {
                if(date && typeof date === 'object'){
                    return moment.unix(date.$date.$numberLong/1000).utc().format(format);
                }
                return moment(date).utc().format(format);
            }
            return '-';
        }
    },
};

function registerSW() {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register('/sw.js');
    }
}

function subscribe() {
    navigator.serviceWorker.ready.then(function(serviceWorkerRegistration) {
        try {
            serviceWorkerRegistration.pushManager.subscribe(
                {
                    userVisibleOnly:true,
                    applicationServerKey: urlBase64ToUint8Array('BILTjfHmOALA7MpRikRzgKTV7xYzJ-dpk9eiNHk6GiZDTPvjVH9wEghanwsGUQiMO63kMzn5g92SMG_-pM8wp14')
                }
            )
                .then(function(subscription) {
                    sendTokenToServer(subscription);
                })
                .catch(function(e) {
                });
        }
        catch (error) {

        }

    });
}

function sendTokenToServer(subscription) {
    let csrf = $('meta[name="csrf-token"]')[0].content;
    $.ajax({
        headers: {
            'X-CSRF-TOKEN': csrf
        },
        type: 'POST',
        url: configRoutes.saveToken,
        data: {
            subscription : JSON.stringify(subscription),
            user: Vue.prototype.$auth.user()._id
        },
    });
}

function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (var i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

export default $site;



// WEBPACK FOOTER //
// ./src/global.js